import React, { useEffect, useState } from "react";
import "./style.css";
import { Link, useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import { useDispatch, useSelector } from "react-redux";
import ProductsService from "../../../services/ProductsService";
import Loader from "../../../common/Loader";
import imageSrc from "../../../assets/banner2.jpg";
import CartService from "../../../services/CartService";
import { toast } from "react-toastify";
import { addToCart } from "../../../store/actions/AuthActions";

const FeatureProducts = () => {
	const tabs = [
		{ label: "All", value: "" },
		{ label: "Best Selling", value: "bestSeller" },
		{ label: "New In", value: "newIn" },
		{ label: "Offer", value: "offer" },
	];
	const [products, setProducts] = useState([]);
	const [selectedTab, setSelectedTab] = useState(tabs[0]);
	const navigate = useNavigate();
	const dispatch = useDispatch();
	const [loader, setLoader] = useState(false);
	const { t } = useTranslation();
	const user = useSelector((state) => state?.user);
	const lang = useSelector((state) => state?.lang?.lang);
	const productsService = new ProductsService();
	const cartService = new CartService();

	useEffect(() => {
		setLoader(true);
		let params = {
			offset: 0,
			limit: 8,
		};
		let paramsFilter = {};
		if (selectedTab?.label === "All") paramsFilter = {};
		if (selectedTab?.label !== "All")
			paramsFilter = { [selectedTab?.value]: true };

		productsService
			?.getList({ ...params, ...paramsFilter })
			.then((res) => {
				if (res?.status === 200) {
					let info = res?.data?.data?.data;
					setProducts(info);
				}
				setLoader(false);
			})
			.catch(() => setLoader(false));
	}, [selectedTab]);

	const addCart = (product) => {
		let data = {
			products: [
				{
					dynamic_variant: [],
					amount: 1,
					product_id: product?.id,
				},
			],
		};
		setLoader(true);
		if (!!user?.user) {
			cartService
				.create(data)
				.then((res) => {
					if (res?.status === 201) {
						toast.success(t("Product Added To Cart"));
						dispatch(
							addToCart({
								...product,
								dynamicVariants: [],
								amount: 1,
								in_stock: product?.amount,
							})
						);
					}
					setLoader(false);
				})
				.catch((e) => {
					setLoader(false);
					if (
						e.response?.data?.message ===
						"product_is_already_Exist_in_your_cart"
					) {
						let data = {
							product_id: product.id,
							amount: 1,
						};
						cartService.update(data).then((res) => {
							if (res?.status === 200) {
								toast.success(t("Product Added To Cart"));
							}
						});
						return;
					}
					toast.error(e.response?.data?.message?.replaceAll("_", " "));
				});
		} else {
			toast.success(t("Product Added To Cart"));
			dispatch(
				addToCart({
					...product,
					dynamicVariants: [],
					amount: 1,
					in_stock: product?.amount,
				})
			);
			setTimeout(() => setLoader(false), [500]);
		}
	};

	return (
		<div className="products-home">
			<h1>{t("products")}</h1>
			<div className="tabs">
				{tabs.map((res, index) => {
					return (
						<span
							className={res?.value === selectedTab?.value ? "active" : ""}
							onClick={() => setSelectedTab(res)}
							key={index}>
							{t(res.label)}
						</span>
					);
				})}
			</div>
			<div className="row">
				{products?.map((product, index) => {
					return (
						<div className="col-md-3 mb-4" key={index}>
							<div className="product-card">
								<img src={product?.product_images[0]?.url} alt="product" />
								<div className="product-body">
									<span className="tag">{t(selectedTab?.label)}</span>
									<Link
										to={`/product/${product?.id}`}
										className="product-title">
										{lang === "en" ? product?.name_en : product?.name_ar}
									</Link>
									<div className="mb-3">
										<span className="price">
											{(product?.offer
												? product?.offerPrice
												: product?.price
											)?.toFixed(3)}{" "}
											{t("KWD")}
										</span>
										<span className="old-price">
											{product?.offer ? product?.price?.toFixed(3) : ""}{" "}
											{product?.offer && t("KWD")}
										</span>
									</div>
									<button onClick={() => addCart(product)}>
										{t("Add To Cart")}
									</button>
								</div>
							</div>
						</div>
					);
				})}
			</div>
		</div>
	);
};

export default FeatureProducts;
